import React, {FC} from "react";

interface Props {
    text: string;
    actual: any;
    val: boolean;
    set(val: boolean):any;
}

export const CheckboxComponent : FC<Props> = (props) => {
    return <div className={"tab"}>
        <input
        type="checkbox"
        checked={props.actual === true}
        onChange={() => props.set(!props.val)}
    />{props.text}
    </div>
}